import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import News from "../pages/news/page";
import ArticleDetail from "../pages/article/detail";
import Events from "../pages/events/page";
import Characters from "../pages/characters/page";
import CharacterDetail from "../pages/characters/detail";
import Updates from "../pages/updates/page";
import UpdateDetail from "../pages/updates/detail";
import GuideDetail from "../pages/guides/detail";
import About from "../pages/about/page";
import Search from "../pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <ArticleDetail /> },
      { path: "events", element: <Events /> },
      { path: "events/:id", element: <ArticleDetail /> },
      { path: "characters", element: <Characters /> },
      { path: "characters/:id", element: <CharacterDetail /> },
      { path: "updates", element: <Updates /> },
      { path: "updates/:id", element: <UpdateDetail /> },
      { path: "guides/:id", element: <GuideDetail /> },
      { path: "about", element: <About /> },
      { path: "search", element: <Search /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;